import React from "react";

/** Brand logo (round AV badge) with optional wordmark. Image lives in /public/logo.jpg */
export function Logo({ size = 56, wordmark = true, light = false, className = "", subtitle = "Collections" }) {
  return (
    <span className={`inline-flex items-center gap-3 ${className}`}>
      <img
        src={`${process.env.PUBLIC_URL || ""}/logo.jpg`}
        alt="Avishka Navya Collections"
        width={size} height={size}
        style={{ width: size, height: size }}
        className={`rounded-full object-cover shrink-0 ${light ? "ring-1 ring-white/40" : ""}`}
        data-testid="brand-logo"
      />
      {wordmark && (
        <span className="text-left leading-none">
          <span className={`block font-serif text-lg sm:text-xl tracking-wide ${light ? "text-white" : "text-neutral-900"}`}>Avishka Navya</span>
          <span className={`block text-[9px] tracking-[0.4em] uppercase mt-1 ${light ? "text-white/80" : "text-[#0E4D34]"}`}>{subtitle}</span>
        </span>
      )}
    </span>
  );
}
